import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Grid } from 'semantic-ui-react';

import { localeData } from '../../../locales/data';
import { formatHTMLMessageHelper } from '../../../shared/helpers/internationalization';
import { logErrorService } from '../../../shared/services';
import { onboardingStatuses, OnboardingStatus } from '../../../types';
import { Card } from '../../Card';
import { List } from '../../List';

type VisibleOnboardingStatus = Exclude<OnboardingStatus, 'NONE'>;

interface OnboardingProps {
  country: string;
  data: Immutable.Map<string, string>;
}

interface OnboardingMessageProps {
  country: string;
  status: VisibleOnboardingStatus;
}

const messageIds: Record<VisibleOnboardingStatus, string> = {
  INVITE: 'dashboardMain.onboarding.invite',
  COUNTRY_UNAVAILABLE: 'dashboardMain.onboarding.countryUnavailable',
  INVITE_APPROVED: 'dashboardMain.onboarding.inviteApproved',
  QUESTIONNAIRE_RECEIVED: 'dashboardMain.onboarding.questionnaireReceived',
  QUESTIONNAIRE_APPROVED: 'dashboardMain.onboarding.questionnaireApproved',
  FORMS_RECEIVED: 'dashboardMain.onboarding.formsReceived',
  FORMS_APPROVED: 'dashboardMain.onboarding.formsApproved',
  BACKGROUND_CHECK_APPROVED: 'dashboardMain.onboarding.backgroundCheckApproved',
  CONSULTANT_APPROVED: 'dashboardMain.onboarding.consultantApproved',
};

function OnboardingMessage({ status, country, intl }: OnboardingMessageProps & InjectedIntlProps) {
  let messageId = messageIds[status];

  if (status === 'QUESTIONNAIRE_APPROVED' && country === 'RU') {
    messageId = 'dashboardMain.onboarding.questionnaireApproved.ru';
  }

  return <p>{formatHTMLMessageHelper(intl, messageId)}</p>;
}

function OnboardingWithoutIntl({ country, data, intl }: OnboardingProps & InjectedIntlProps) {
  const status = data.getIn(['status']) as OnboardingStatus;
  if (typeof status !== 'string' || !onboardingStatuses.includes(status)) {
    logErrorService(`Invalid onboarding status ${status} should be one of [${onboardingStatuses.join(', ')}]'`, null);

    return null;
  }

  if (status === 'NONE') {
    return null;
  }

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        title={intl.formatMessage({
          id: 'dashboardMain.onboarding',
          defaultMessage: localeData.en['dashboardMain.onboarding'],
        })}
      >
        <List
          title={intl.formatMessage({
            id: 'dashboardMain.onboarding.applicationStatus',
            defaultMessage: localeData.en['dashboardMain.onboarding.applicationStatus'],
          })}
        >
          <OnboardingMessage status={status} intl={intl} country={country} />
        </List>
      </Card>
    </Grid.Column>
  );
}

export const Onboarding = injectIntl(OnboardingWithoutIntl);
